import $ from 'jquery';

$(function() {
    
    var page = 1;
    var $search = $('#talentadore-filter-search');
    var $location = $('#talentadore-filter-location');
    var $company = $('#talentadore-filter-company');
    
    // Filters
    $('#talentadore-filters').on('submit', function(e) {
        e.preventDefault();
        const searchVal = $search.val();
        const locationVal = $location.val();
        const companyVal = $company.val();
        updateUrlParams(searchVal, locationVal, companyVal);
        hoyry_talentadore_search_block_get_jobs(searchVal, locationVal, companyVal);
    });
    
    // Location change
    $location.on('change', function() {
        $(this).removeClass('placeholder');
    });
    
    // Company change
    $company.on('change', function() {
        $(this).removeClass('placeholder');
    });
    
    // Show all
    $('#talentadore-show-all').on('click', function() {
        updateUrlParams('', '', '');
        hoyry_talentadore_search_block_get_jobs('', '', '', 'list');
    });
    
    // Load more
    $('#talentadore-load-more button').on('click', function() {
        page++;
        hoyry_talentadore_search_block_get_jobs( $search.val(), $location.val(), $company.val() );
    });
    
    // Get jobs
    var hoyry_talentadore_search_block_get_jobs = function( search = '', location = '', company = '', type = 'card' ) {
        
        $.ajax({
            
            dataType: 'json',
            type: 'GET',
            url: hoyry_talentadore_search_block_rest_url[0] + 'get_jobs',
            data: {
                lang: $('html').attr('lang').substring(0, 2),
                search: search,
                location: location,
                company: company,
                type: type,
                page: page
            }
            
        }).done( function( objData, textStatus, jqXHR ) {
            
            var status = objData.status;
            var data = objData.data;
            var error_message = objData.error_message;
            var debug = objData.debug;
            
            if( status == 'success' ) {
                
                // if( page == 1 || type == 'list' ) $('#talentadore-results').html( data['html'] );
                // else $('#talentadore-results').append( data['html'] );
                $('#talentadore-results').html( data['html'] );
                
                if( data['load_more'] == 1 && type == 'card' ) $('#talentadore-load-more').show();
                else $('#talentadore-load-more').hide();
                
                $('#talentadore-count .count').text( data['count'] );
                
                if( type == 'card' && ( $search.val() || $location.val() || $company.val() ) ) {
                    $('#talentadore-count .search').show();
                    $('#talentadore-count .all').hide();
                }
                else {
                    $('#talentadore-count .search').hide();
                    $('#talentadore-count .all').show();
                }
                
            }
            else {
                console.log( error_message );
            }
            
            if( debug ) {
                console.log( debug );
            }
            
        }).fail( function( jqXHR, textStatus, errorThrown ) {
            console.log(errorThrown);
            console.log(MLHttpRequest);
        });
        
    }
    
    // Add this new function to handle URL parameters
    function updateUrlParams(search, location, company) {
        const url = new URL(window.location);
        
        if (search) url.searchParams.set('search', search);
        else url.searchParams.delete('search');
        
        if (location) url.searchParams.set('location', location);
        else url.searchParams.delete('location');
        
        if (company) url.searchParams.set('company', company);
        else url.searchParams.delete('company');
        
        window.history.pushState({}, '', url);
    }
    
    // Add this to initialize from URL parameters
    function initFromUrlParams() {
        const url = new URL(window.location);
        const searchParam = url.searchParams.get('search') || '';
        const locationParam = url.searchParams.get('location') || '';
        const companyParam = url.searchParams.get('company') || '';
        
        if (searchParam) $search.val(searchParam);
        if (locationParam) $location.val(locationParam);
        if (companyParam) $company.val(companyParam);
        
        // Only call get_jobs if we have URL parameters
        if (searchParam || locationParam || companyParam) {
            hoyry_talentadore_search_block_get_jobs(searchParam, locationParam, companyParam);
            return true; // Signal that we've loaded jobs
        }
        return false; // Signal that we haven't loaded jobs
    }
    
    // Initialize from URL parameters
    const jobsLoaded = initFromUrlParams();
    
    // Only call get_jobs if we haven't already loaded them from URL parameters
    if (!jobsLoaded) {
        hoyry_talentadore_search_block_get_jobs($search.val(), $location.val(), $company.val());
    }
	
});